import {
  authImpersonate,
  authLogin,
  authLogout,
  authStopImpersonation,
} from '@/shared/api/generated/auth/auth';

import { clearSession, setSession } from './session';

/**
 * Вход по адресу почты и паролю.
 *
 * Ошибку не глотает: форма показывает её человеку сама. Здесь только то, что
 * должно случиться при успехе.
 */
export async function signIn(email: string, password: string): Promise<void> {
  const response = await authLogin({ email, password });

  // Сгенерированный клиент описывает ответ объединением всех кодов из спеки, и
  // сузить его нужно явно. До этой строки доходит только успех: `facetaFetch`
  // выбрасывает ошибку на любом неуспешном ответе — но типы об этом не знают,
  // и полагаться на такое знание молча не стоит.
  if (response.status !== 200) {
    throw new Error('Неожиданный ответ на запрос входа');
  }

  setSession(response.data.access_token, response.data.user, response.data.impersonated);
}

/**
 * Выход.
 *
 * Сеанс на клиенте гасится в любом случае, даже если запрос не дошёл. Иначе
 * человек, нажавший «Выйти» на чужом компьютере при отвалившейся сети,
 * остался бы в системе — а это ровно тот случай, ради которого выход и
 * нажимают. Серверный сеанс при этом всё равно кончится по сроку.
 */
export async function signOut(): Promise<void> {
  try {
    await authLogout();
  } finally {
    clearSession();
  }
}

/**
 * Зайти под пользователя для поддержки.
 *
 * Прежний сеанс владельца платформы при этом закрывается на клиенте: cookie
 * с токеном обновления одна, и держать в браузере два входа разом всё равно
 * нельзя. Вернуться обратно — `stopImpersonation`.
 */
export async function impersonate(userID: string): Promise<void> {
  const response = await authImpersonate(userID);

  if (response.status !== 200) {
    throw new Error('Неожиданный ответ на вход от имени пользователя');
  }

  setSession(response.data.access_token, response.data.user, response.data.impersonated);
}

/** Вернуться в свою учётную запись. */
export async function stopImpersonation(): Promise<void> {
  const response = await authStopImpersonation();

  if (response.status !== 200) {
    throw new Error('Неожиданный ответ на возврат');
  }

  setSession(response.data.access_token, response.data.user, response.data.impersonated);
}
